import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IVehicleType } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = (hasCity: boolean) => yup.object({
    name: yup.string().required("Vehicle Type is required"),
    capacity: yup
        .number()
        .typeError("Capacity must be a number")
        .min(0, "Capacity must be a positive number")
        .required("Capacity is required"),

    ratePerKm: yup
        .number()
        .typeError("Price must be a number")
        .min(0, "Price must be a positive number")
        .when([], {
            is: () => hasCity,
            then: s => s.required("Price is required"),
            otherwise: s => s.notRequired().nullable(),
        }),

    minCharge: yup
        .number()
        .typeError("Min Charge must be a number")
        .min(0, "Min Charge must be a positive number")
        .when([], {
            is: () => hasCity,
            then: s => s.required("Min Charge is required"),
            otherwise: s => s.notRequired().nullable(),
        }),

    driverCharge: yup
        .number()
        .typeError("Driver Charge must be a number")
        .min(0, "Driver Charge must be a positive number")
        .when([], {
            is: () => hasCity,
            then: s => s.required("Driver Charge is required"),
            otherwise: s => s.notRequired().nullable(),
        }),

    dayCharge: yup
        .number()
        .typeError("Day Charge must be a number")
        .min(0, "Day Charge must be a positive number")
        .when([], {
            is: () => hasCity,
            then: s => s.required("Day Charge is required"),
            otherwise: s => s.notRequired().nullable(),
        }),

    nightCharge: yup
        .number()
        .typeError("Night Charge must be a number")
        .min(0, "Night Charge must be a positive number")
        .when([], {
            is: () => hasCity,
            then: s => s.required("Night Charge is required"),
            otherwise: s => s.notRequired().nullable(),
        }),

    isActive: yup.boolean().required("Status is required"),
    desc: yup.string().nullable(),
});


interface Iprops {
    cityId?: number,
    singleData: IVehicleType,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IVehicleType>({
        resolver: yupResolver(schema(!!props.cityId)),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IVehicleType) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        body.cityId = props.cityId;

        const response = await Fetch(`vehicletype${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit Vehicle Type" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} required label="Vehicle Type" control={control} name="name" error={errors.name?.message} />
                <JVInput column={1} type="number" required label="Capacity" control={control} name="capacity" error={errors.capacity?.message} />
                {props.cityId && (
                    <> <JVInput column={1} type="number" required label="Rate/Km" control={control} name="ratePerKm" error={errors.ratePerKm?.message} />
                        <JVInput type="number" required label="Min Charge" control={control} name="minCharge" error={errors.minCharge?.message} />
                        <JVInput type="number" required label="Driver Charge" control={control} name="driverCharge" error={errors.driverCharge?.message} />
                        <JVInput type="number" required label="Day Charge" control={control} name="dayCharge" error={errors.dayCharge?.message} />
                        <JVInput type="number" required label="Night Charge" control={control} name="nightCharge" error={errors.nightCharge?.message} /></>
                )}
                <JVInput column={1} label="Description" control={control} name="desc" error={errors.desc?.message} />
                {props.singleData.id && <JVCheckbox column={2} label="Status" control={control} name="isActive" />}

                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}